module.exports = __webpack_public_path__ + "img/Bloque-04.9a090a7b.png";